import { Routes } from '@angular/router';
import { AppDashboardComponent } from './app-dashboard/app-dashboard.component';
import { AppAuthComponent } from './app-auth/app-auth.component';
import { apihGuard } from './_Guards/apih-guard';
import { authRedirectGuard } from './_Guards/auth-redirect-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component:AppAuthComponent,
    canActivate: [authRedirectGuard],
    loadChildren: () => import('./app-auth/app-auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'dashboard',
    component:AppDashboardComponent,
    canActivate: [apihGuard],
    loadChildren: () => import('./app-dashboard/app-dashboard.routes').then(m => m.DASHBOARD_ROUTES)
  },
];
